import { FunctionComponent, memo } from "react";
import { NumericValue } from "@edgetier/client-components";
import { useInteractionsCount } from "hooks-for/interactions/use-interactions-counts";
import { IProps } from "./interactions-table-count.types";
import "./interactions-table-count.scss";

/**
 * Display how many interactions are on display out of the total available. If there are no interactions, nothing will
 * display because the table beneath already has a "No results found" type message.
 * @param props.displayCount Number of interactions on display.
 * @param props.parameters   Backend parameters to count interactions.
 * @param props.queryOptions Any options to pass to React Query.
 * @returns
 */
export const InteractionsTableCount: FunctionComponent<IProps> = ({ displayCount, parameters, queryOptions = {} }) => {
    const { data: interactionsCount } = useInteractionsCount(parameters, { ...queryOptions });

    return (
        <>
            {typeof interactionsCount === "number" && displayCount > 0 && interactionsCount > 0 && (
                <>
                    ({displayCount} of <NumericValue value={interactionsCount} />)
                </>
            )}
        </>
    );
};

export default memo(InteractionsTableCount);
